/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCashtagStatus} from '../api'

 export const useQueryGetCashtagStatus = createReactQueryHook('getCashtagStatus', getCashtagStatus)
